import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["src", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataTableHeader = _resolveComponent("DataTableHeader")!
  const _component_AddDocuments = _resolveComponent("AddDocuments")!

  return (_openBlock(), _createElementBlock("table", null, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (header) => {
          return (_openBlock(), _createBlock(_component_DataTableHeader, {
            class: "column",
            key: header.label,
            header: header
          }, null, 8, ["header"]))
        }), 128))
      ])
    ]),
    (_ctx.tableData.length > 0)
      ? (_openBlock(), _createElementBlock("tbody", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (items) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: items.id
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVisibleItems(Object.entries(items)), (item, i) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: item[0],
                  style: _normalizeStyle(_ctx.getStyle(_ctx.tableHeader[i]))
                }, [
                  (item[0] === 'facture')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (item[1] === undefined && _ctx.isLastItem(items))
                          ? (_openBlock(), _createBlock(_component_AddDocuments, {
                              key: 0,
                              documents: [],
                              onAdd: _ctx.addFile
                            }, null, 8, ["onAdd"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              (item[1] === undefined)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                                : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                    _createTextVNode(_toDisplayString(item[1].name) + " ", 1),
                                    (_ctx.isLastItem(items))
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          class: "trash-icon",
                                          src: _ctx.deleteIcon,
                                          alt: "delete",
                                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteFacture()))
                                        }, null, 8, _hoisted_6))
                                      : _createCommentVNode("", true)
                                  ]))
                            ]))
                      ]))
                    : (item[0] === 'numeroCompteur')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (_ctx.isLastItem(items))
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.numeroCompteur) = $event))
                              }, null, 512)), [
                                [_vModelText, _ctx.numeroCompteur]
                              ])
                            : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item[1]), 1))
                        ]))
                      : _createCommentVNode("", true)
                ], 4))
              }), 128)),
              _createElementVNode("td", null, [
                _createElementVNode("div", null, [
                  (!_ctx.isLastItem(items))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "pointer",
                        src: _ctx.deleteIcon,
                        alt: "delete",
                        onClick: ($event: any) => (_ctx.deleteRow(items))
                      }, null, 8, _hoisted_9))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}